import type { RequestFn } from '../client';

export class Files {
  constructor(private readonly request: RequestFn) {}

  /** Upload a file. `POST /files` */
  async create(params: Record<string, unknown>): Promise<Record<string, unknown>> {
    return this.request('POST', '/files', { body: params });
  }

  /** Retrieve/download a file. `GET /files/{fileId}` */
  async retrieve(fileId: string): Promise<Record<string, unknown>> {
    return this.request('GET', `/files/${encodeURIComponent(fileId)}`);
  }

  /** Delete a file. `DELETE /files/{fileId}` */
  async delete(fileId: string): Promise<Record<string, unknown>> {
    return this.request('DELETE', `/files/${encodeURIComponent(fileId)}`);
  }
}
